<template>
    <div class="create-button">
        <base-button
            @click="visible = true"
            icon="fas fa-plus"
            class="is-link is-outlined"
            text="Create Team"/>

        <base-modal title="Create new Team" :visible="visible" @close="close">
            <base-backend-errors :data="create.error"/>
            <team-form @submit="createTeam" @cancel="close" :loading="create.loading"/>
        </base-modal>

        <team-members-modal
            @close="close"
            :visible="show_members"
            :team_id="create.data.id"
            button="Complete"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import TeamForm from './TeamForm.vue';
import TeamMembersModal from './TeamMembersModal.vue';


export default {
    components: { TeamMembersModal, TeamForm },
    data() {
        return { visible: false, show_members: false };
    },
    computed: mapState('teams', ['create']),
    methods: {
        createTeam(data) {
            this.$store.dispatch('teams/create', data).then(() => {
                this.$emit('created');
                this.visible = false;
                this.show_members = true;
            });
        },
        close() {
            this.visible = false;
            this.show_members = false;
        },
    },
};
</script>

<style scoped>
    .create-button {
        margin-right: 1rem;
    }
</style>
